import { render } from "./Forms.vue?vue&type=template&id=1ea65abc&scoped=true"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1ea65abc"

export default script